import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import businesLogo from './busines_logo.json';

const BusinesLogo = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const anim = lottie.loadAnimation({
      container: ref.current,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: businesLogo,
    });

    return () => anim.destroy();
  }, []);

  return <div ref={ref} style={{ width: 200, height: 200 }} />;
};

export default BusinesLogo;
